if(!customElements.get('localization-popup')){
    class LocalizationPopup extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.localizationOptions = this.querySelectorAll('.localization-options');
            this.buttons = this.querySelectorAll('.button-locale');
            this.localeList = this.querySelectorAll('.localization-options a');

            // open popup by clicking icons
            document.querySelectorAll('.localization-icon, .localization-button').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'localization-popup'){
                    item.addEventListener('click', (e) => {
                        this.openPopup(e, item);
                    });
                }
            });

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener("keydown", e => {
                    if(e.code === 'Enter'){
                        this.closePopup();
                    }
                });
            });
            this.addEventListener('click', e => {
                if(e.target === this) this.closePopup();
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });
        }

        openPopup(e = null, triggerElement = null){
            if(e){
                e.preventDefault();
            }

            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);
            this.addFocus();
        }

        closePopup(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        addFocus(){
            if(this.buttons.length > 0){
                setTimeout(() => {
                    this.buttons[0].focus();
                }, 100);
            }
        }
    }

    customElements.define('localization-popup', LocalizationPopup);
}